<template>
  <div>
    <div id="livraison" @click="routerOT(resultExpFiltersData.id)">
      <div id="top_lv">
        <div class="icone">
          <img v-if="resultExpFiltersData.statutsuivi === 0" src="../../public/images/camion_gris.png" title="Aucune information"/>
          <img v-if="resultExpFiltersData.statutsuivi === 1" src="../../public/images/camion_vert.png" title="Livraison effectuée"/>
          <img v-if="resultExpFiltersData.statutsuivi === 2" src="../../public/images/camion_jaune.png" title="En cours de livraison"/>
          <img v-if="resultExpFiltersData.statutsuivi === 3" src="../../public/images/camion_orange.png" title="Anomalie potentielle"/>
          <img v-if="resultExpFiltersData.statutsuivi === 4" src="../../public/images/camion_rouge.png" title="Livraison impossible"/>
        </div>
        <div class="ecrit">
          <div class="info">
            <p>{{ resultExpFiltersData.numero }}</p>
          </div>
          <div class="info_destinataire">
            <p>{{ resultExpFiltersData.destinataire_nom }}</p>
            <p>{{ resultExpFiltersData.destinataire_codepostal }} {{ resultExpFiltersData.destinataire_ville }}</p>
          </div>
          <div class="info">
            <p>{{ resultExpFiltersData.transporteur_nom }}</p>
          </div>
          <div class="info">
            <p>{{ resultExpFiltersData.tournee_nom }}</p>
          </div>
          <div class="info">
            <p v-if="resultExpFiltersData.consignation_datecloture !== null">{{ formattedDateCloture }}</p>
            <p v-else>Non clôturé</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDateMixin from '../mixins/formatDateMixin.js'
import router from '../router/index.js'

export default {
  name: 'ExpediteurFiltersData',
  data: () => ({
    
  }),
  computed: {
    formattedDateCloture() {
      return this.formatDate(this.resultExpFiltersData.consignation_datecloture)
    }
  },
  mixins: [
    formatDateMixin
  ],
  props: [
    'resultExpFiltersData'
  ],
  methods: {
    routerOT(id) {
      router.push('/expediteur/resultats/' + id)
    }
  }
}

</script>

<style scoped lang="scss">
  img {
    width: 60px;
    margin: auto 0;
  }
  #livraison {
    width: 80%;
    color: #23262c;
    margin: 1rem auto;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: rgb(236, 239, 241);
    font-size: 1em;
    transition: background 0.5s ease-in-out;
    &:hover {
      background: rgb(240, 255, 255);
    }
  }
  #top_lv {
    display: flex;
  }
  .ecrit {
    width: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .info {
    width: 15%;
  }
  .info_destinataire {
    width: 30%;
  }
  #infos_tournee {
    width: 75%;
    display: flex;
  }
  #bottom_lv {
    display: flex;
    justify-content: space-around;
  }
  .statutSuivi {
    width: 15%;
    right: 0px;
    text-align: center;
  }
  .icone {
    width: 10%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
  @media screen and (max-width: 1400px) {
    .icone {
      width: 12%;
    }
  }
  @media screen and (max-width: 1700px) {
    .icone {
      width: 15%;
    }
  }
</style>